export const CONTENT_CONTEXT_SCHEMA_VERSION = 'content-context.v1';
export const CONTENT_CONTEXT_TOPIC_MAX = 2000;
export const CONTENT_CONTEXT_AUDIENCE_MAX = 500;
export class ContentContextInputError extends Error {
    field;
    constructor(field) {
        super(`Invalid content context field: ${field}`);
        this.field = field;
        this.name = 'ContentContextInputError';
    }
}
/** Omission is not a default: legacy business-mode migration belongs to the caller. */
export function parseContentContextInput(raw) {
    if (raw === null || typeof raw !== 'object' || Array.isArray(raw))
        throw new ContentContextInputError('body');
    const value = raw;
    if (value['kind'] === 'BUSINESS_PROFILE') {
        if (Object.keys(value).some((key) => key !== 'kind'))
            throw new ContentContextInputError('body');
        return { kind: 'BUSINESS_PROFILE' };
    }
    if (value['kind'] !== 'INDEPENDENT_TOPIC')
        throw new ContentContextInputError('kind');
    if (Object.keys(value).some((key) => !['kind', 'topic', 'audience'].includes(key)))
        throw new ContentContextInputError('body');
    const topic = value['topic'];
    if (typeof topic !== 'string' ||
        topic.trim().length === 0 ||
        Array.from(topic).length > CONTENT_CONTEXT_TOPIC_MAX)
        throw new ContentContextInputError('topic');
    const audience = value['audience'];
    if (audience !== undefined &&
        audience !== null &&
        (typeof audience !== 'string' ||
            Array.from(audience).length > CONTENT_CONTEXT_AUDIENCE_MAX))
        throw new ContentContextInputError('audience');
    return {
        kind: 'INDEPENDENT_TOPIC',
        topic,
        // Preserve source bytes; only empty optional input becomes null.
        audience: typeof audience === 'string' && audience.trim() ? audience : null,
    };
}
//# sourceMappingURL=content-context.js.map